import React from 'react';
import useLocalStorage from 'hooks/useLocalStorage';

function FirstLoad() {
  const [config, setConfig] = useLocalStorage('qp-inital-load', false);
  React.useLayoutEffect(() => {
    if (!config) {
      setConfig(true);
    }
  }, []);
  return <React.Fragment></React.Fragment>;
}

export default FirstLoad;
